import React, {useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import {getUser} from "./redux/profile.action";
import {setProfileEmpty} from "./redux/profile.action";
import {globalStyle} from "../../assets";
import {
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  View,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import BasicDetails from "./childComponents/BasicDetails";
import {SafeAreaView} from "react-native-safe-area-context";
import FastImage from "../../common/FastImage";
import {back_arrow} from "../../utils/images";
import FormTextLabel from "../../commonComponents/FormTextLabel";
import {globalConfigurableData} from "../../utils/globalConstant";
import {Network} from "../../utils/network";
import { Icon } from '@iconify/react';
import { useToast } from '../../components/core/Toast';
import { INDIA } from '../../utils/constants';

const Profile = ({navigation, profileData, getUser, setProfileEmpty}) => {
  const [image, setImage] = useState(null);
  const { toast } = useToast();

  useEffect(() => {
    getUser();
  }, []);

  const onBasicDetailSubmit = async (data) => {
    try {
      const requestData = {
        displayname: data.userName,
        dob: data.dateOfBirth,
        email: data.Email
      };

      // Only include pincode for Indian users
      if (profileData?.region_code === INDIA) {
        requestData.pincode = data.pinCode;
      }

      const res = await Network.updateUserDetails(requestData);
      
      if (res?.data?.success) {
        toast({
          title: 'Success',
          description: 'Changes Saved!',
          variant: 'success'
        });
        getUser();
      } else {
        toast({
          title: 'Error',
          description: res?.data?.error || 'Failed to update profile',
          variant: 'destructive'
        });
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: error?.message || 'Something went wrong',
        variant: 'destructive'
      });
    }
  };

  const onImageChange = (img) => {
    setImage(img);
  };

  return (
    <SafeAreaView style={globalStyle.container}>
      <View style={styles.headerContainer}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}>
          <Icon 
            icon="tabler:arrow-left"
            style={styles.backIcon}
            color={globalConfigurableData.primaryTextColor1}
            width="24"
            height="24"
          />
        </TouchableOpacity>
        <FormTextLabel
          labelStyles={styles.headerTitle}
          label={"Profile"}
        />
        <View style={styles.rightPlaceholder} />
      </View>
      <KeyboardAvoidingView
        behavior={Platform.OS === "ios" ? "padding" : "height"}
        style={{flex: 1}}>
        <ScrollView style={{paddingHorizontal: 16}}>
          <BasicDetails
            profileData={profileData}
            onBasicDetailSubmit={onBasicDetailSubmit}
            setProfileEmpty={setProfileEmpty}
            onImageChange={onImageChange}
            image={image}
          />
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    height: 56,
    backgroundColor: globalConfigurableData.globalThemeColor,
    borderBottomWidth: 1,
    borderBottomColor: globalConfigurableData.borderColor,
  },
  backButton: {
    padding: 8,
    marginLeft: -8,
  },
  backIcon: {
    width: 24,
    height: 24,
  },
  headerTitle: {
    ...globalStyle.appFontSize18,
    color: globalConfigurableData.primaryTextColor1,
    flex: 1,
    textAlign: 'center',
    marginHorizontal: 16,
  },
  rightPlaceholder: {
    width: 24,
  },
});

const mapStateToProps = ({profile}) => ({
  profileData: profile.profileData,
});

const mapDispatchToProps = {
  getUser,
  setProfileEmpty,
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
